import React, { useMemo } from "react";

function ProfilePostingRate({ recentRequests, rateLimitResult, stale }) {
  const hourlyThreshold = globalThis.QwotedAdmin?.REQUEST_RATE_LIMIT_HOURLY_THRESHOLD;
  const dailyThreshold = globalThis.QwotedAdmin?.REQUEST_RATE_LIMIT_DAILY_THRESHOLD;

  const counts = useMemo(() => {
    const now = Date.now();
    const oneHourAgo = now - 60 * 60 * 1000;
    const oneDayAgo = now - 24 * 60 * 60 * 1000;
    const oneWeekAgo = now - 7 * 24 * 60 * 60 * 1000;

    let hourly = 0;
    let daily = 0;
    let weekly = 0;

    recentRequests.forEach((req) => {
      const ts = new Date(req.posted_at).getTime();
      if (ts > oneHourAgo) hourly += 1;
      if (ts > oneDayAgo) daily += 1;
      if (ts > oneWeekAgo) weekly += 1;
    });

    return { hourly, daily, weekly, monthly: recentRequests.length };
  }, [recentRequests]);

  if (stale) {
    return (
      <div className="mt-2 pt-2 border-top">
        <div className="d-flex align-items-center gap-2 py-2">
          <i className="fa fa-spinner fa-spin text-info" />
          <span className="fw-medium">Rate Limit</span>
          <span className="text-muted small ms-auto">Re-evaluating...</span>
        </div>
      </div>
    );
  }

  const isOverLimit = rateLimitResult
    ? rateLimitResult.pass === false
    : (hourlyThreshold && counts.hourly > hourlyThreshold) || (dailyThreshold && counts.daily > dailyThreshold);

  const exceededWindow = rateLimitResult?.window;

  return (
    <div className="mt-2 pt-2 border-top">
      <div className="d-flex align-items-start gap-2 py-2">
        {isOverLimit ? (
          <i className="fa fa-times-circle text-danger mt-1" />
        ) : (
          <i className="fa fa-check-circle text-success mt-1" />
        )}
        <div className="flex-grow-1">
          <span className="fw-medium">Rate Limit</span>
          {isOverLimit && rateLimitResult?.window && (
            <span className="text-muted small d-block">
              Exceeded {rateLimitResult.window} limit ({rateLimitResult.count}/{rateLimitResult.threshold})
            </span>
          )}
        </div>
      </div>

      <div className="small text-muted mt-1 ms-4">
        <div className="fw-medium mb-1">Recent Activity</div>
        <div className="d-flex flex-wrap gap-3">
          <WindowCount
            label="1h"
            count={counts.hourly}
            threshold={hourlyThreshold}
            exceeded={exceededWindow === "hourly"}
          />
          <WindowCount
            label="24h"
            count={counts.daily}
            threshold={dailyThreshold}
            exceeded={exceededWindow === "daily"}
          />
          <WindowCount label="7d" count={counts.weekly} />
          <WindowCount label="30d" count={counts.monthly} />
        </div>
      </div>
    </div>
  );
}

function WindowCount({ label, count, threshold, exceeded }) {
  const className = exceeded ? "text-danger fw-bold" : "";

  return (
    <span className={className}>
      {label}: {count}
      {threshold != null && `/${threshold}`}
    </span>
  );
}

export default ProfilePostingRate;
